var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoinLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.983,
    height: 22.983,
    viewBox: "0 0 22.983 22.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bitcoin-circle-svgrepo-com",
    d: "M11.16,8.829h4.663a2.331,2.331,0,1,1,0,4.663M11.16,8.829v4.663m0-4.663H9.412m1.749,0V7.08m4.663,6.412H11.16m4.663,0a2.331,2.331,0,1,1,0,4.663H11.16m0-4.663v4.663m0,0H9.412m1.749,0V19.9m3.5-11.075V7.08m0,12.823V18.155m9.326-4.663A10.492,10.492,0,1,1,13.492,3,10.492,10.492,0,0,1,23.983,13.492Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinLight);
export default __webpack_public_path__ + "static/media/bitcoinLight.950a247a2e11e192b041a7697371ff51.svg";
export { ForwardRef as ReactComponent };